import React from 'react';
import TableSkeleton from 'components/TableSkeleton';

const OutstandingVideoAnalysisSkeleton = () => {
  return (
    <div className="container mx-auto mt-6 max-sm:mt-ds-xl max-sm:px-4">
      <h5 className="typography-product-heading-compact-desktop max-sm:typography-product-subheading mb-ds-xl max-sm:mb-ds-md">
        Outstanding Video Analysis
      </h5>
      <TableSkeleton layout="table" rows={3} />
    </div>
  );
};

export default OutstandingVideoAnalysisSkeleton;
